import { Component, OnInit, Inject, ViewChild, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { environment } from '@env/environment';
import { SearchStateService, ReqService } from '@core/services';
import { IHotelIntro } from '@core/models/modals';
import { MbDialogRef, MB_DIALOG_DATA, MbDialogBody, MbDialogHeader } from '@am/moebius';
import { DialogWrapperComponent } from '@modals/dialog-wrapper/dialog-wrapper.component';
import { SharedModule } from '@shared/shared.module';

@Component({
    selector: 'app-modal-hotel-intro',
    standalone: true,
    imports: [CommonModule, MbDialogHeader, MbDialogBody, SharedModule],
    templateUrl: './hotel-intro.component.html',
    styleUrls: ['./hotel-intro.component.scss']
})
export class ModalHotelIntroComponent
  extends DialogWrapperComponent
  implements AfterViewInit, OnInit
{
  @ViewChild('hotelsMap') hotelsMap: any;

  public brand: string;
  public map: google.maps.Map;
  public googleMaps = google.maps;
  public isMobile: boolean;
  public markers: google.maps.Marker[] = [];
  public showMap: boolean;
  public optionsMap: {
    zoom: number;
    center: string;
    marker: {
      coords: [number, number];
      icon: string;
    };
  };
  public locale: string;
  public hotelPosition: string;
  public showAvuxi: boolean;
  public isCvc: boolean;
  public isBot: boolean;

  constructor(
    private reqService: ReqService,
    private searchStateService: SearchStateService,
    public dialogRef: MbDialogRef<ModalHotelIntroComponent>,
    @Inject(MB_DIALOG_DATA) public dialogData: IHotelIntro,
  ) {
    super();
    this.showMap = true;
    this.isCvc = this.reqService.isCVC();
    this.brand = this.reqService.getBrand();
    this.isBot = this.reqService.isBot();
  }

  ngOnInit() {
    super.ngOnInit();
    this.locale = this.reqService.getLocale();
    this.hotelPosition =
      this.dialogData.hotel_position.latitude +
      ',' +
      this.dialogData.hotel_position.longitude;

    this.showAvuxi =
      (!this.isBot && environment.production) ||
      this.searchStateService.getLocationSearch().poi;
  }

  ngAfterViewInit() {
    if (!this.showAvuxi) {
      this.initMap(
        this.dialogData.hotel_position.latitude,
        this.dialogData.hotel_position.longitude,
      );
      this.createFirstCluster(this.dialogData);
    }
  }

  close() {
    this.showMap = false;
    this.dialogRef.close();
  }

  private initMap(lat: number, lng: number) {
    if (!this.map) {
      const mapStyles: google.maps.MapTypeStyle[] = [
        {
          elementType: 'labels',
          featureType: 'poi',
          stylers: [{ visibility: 'off' }],
        },
      ];

      const mapProp: google.maps.MapOptions = {
        center: new google.maps.LatLng(lat, lng),
        disableDefaultUI: true,
        mapTypeId: this.googleMaps.MapTypeId.ROADMAP,
        styles: mapStyles,
        zoom: 17,
        zoomControl: this.isMobile,
        gestureHandling: 'greedy',
      };

      this.map = new this.googleMaps.Map(this.hotelsMap.nativeElement, mapProp);
    }
  }

  private createFirstCluster(hotel) {
    const hotelIcon = `/hotels/dist/es-AR/browser/assets/images/${
      this.isCvc ? 'cvc' : 'almundo'
    }-hotel-with-bell-pin.svg`;
    const marker = new this.googleMaps.Marker({
      position: new this.googleMaps.LatLng(
        hotel.hotel_position.latitude,
        hotel.hotel_position.longitude,
      ),
      map: this.map,
      icon: hotelIcon,
    });
    marker.set('id', hotel.id);
    this.markers.push(marker);
  }
}
